export const comparecencias_item = [
  {
    comparecencias_item_nombre: "COMPARECENCIA 2025",
    comparecencias_item_url: "/contenido/informacion/publicaciones/COMPARECENCIA 2025.pdf",
    comparecencias_item_titulo: "Año 2025"   
  },
  {
    comparecencias_item_nombre: "COMPARECENCIA 2024",
    comparecencias_item_url: "/contenido/informacion/publicaciones/COMPARECENCIA 2024.pdf",
    comparecencias_item_titulo: "Año 2024"   
  },
  {
    comparecencias_item_nombre: "COMPARECENCIA 2023",
    comparecencias_item_url: "/contenido/informacion/publicaciones/COMPARECENCIA 2023.pdf",
    comparecencias_item_titulo: "Año 2023"   
  },
  {
    comparecencias_item_nombre: "COMPARECENCIA 2021",
    comparecencias_item_url: "/contenido/informacion/publicaciones/COMPARECENCIA 2021.pdf",
    comparecencias_item_titulo: "Año 2021"   
  },
  {
    comparecencias_item_nombre: "COMPARECENCIA 2020",
    comparecencias_item_url: "/contenido/informacion/publicaciones/COMPARECENCIA 2020.pdf",
    comparecencias_item_titulo: "Año 2020"
  },
  {
    comparecencias_item_nombre: "COMPARECENCIA 2019",
    comparecencias_item_url: "/contenido/informacion/publicaciones/COMPARECENCIA 2019.pdf",
    comparecencias_item_titulo: "Año 2019"
  },
  {
    comparecencias_item_nombre: "COMPARECENCIA 2018",
    comparecencias_item_url: "/contenido/informacion/publicaciones/COMPARECENCIA 2018.pdf",
    comparecencias_item_titulo: "Año 2018"
  },
  {
    comparecencias_item_nombre: "COMPARECENCIA 2017",
    comparecencias_item_url: "/contenido/informacion/publicaciones/COMPARECENCIA 2017.pdf",
    comparecencias_item_titulo: "Año 2017"
  },
];
